<template>
  <v-app id="inspire">
    <v-content class="content">
      <v-container
        fluid
      >
        <v-row
          align="start"
          justify="center"
          class="pa-0"
        >
          <v-col
            cols="10"
            sm="6"
            md="5"
            lg="4"
            xl="4"
            class="pa-0 mt-0"
          >
          <ErrorSnackbar :errorMessage="this.authErrors.errorMessage" :errorSnackbar.sync="errorSnackbar"/>
          <div class = "title-container">
              <v-list-item>
                <v-list-item-content class="ma-0 pa-0">
                  <v-list-item-title class="headline mb-1">
                    <v-icon id="icon-style" size="2.4vh">fas fa-clouds</v-icon>
                  </v-list-item-title>
                  <v-list-item-subtitle class ="icon-subtitle">multicloud</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content class="ma-0 pa-0">
                  <v-list-item-title class ="login-title ma-0 pa-0">Log in</v-list-item-title>
                  <v-list-item-subtitle  class="ma-0 pa-0">
                    <hr class="underscore">
                  </v-list-item-subtitle>
                  <p class="login-subtitle">PSC Multicloud Platform</p>
                </v-list-item-content>
              </v-list-item>
          </div>
            <v-form @submit.prevent="onSignin">
              <v-card class="elevation-0 pl-2 pr-2 pb-0 pt-0 ma-0" color="rgba(255, 0, 0, 0)"> 
                <v-card-text class="justify-center pr-2 pl-2 pb-0 pt-0">
                    <v-text-field 
                      class="login"
                      :class="{'login': !errors && $v.credentials.username.required && $v.credentials.username.email,
                      'login-error': errors && !$v.credentials.username.required || !$v.credentials.username.email}"
                      name="Username"
                      type="text"
                      placeholder="Email"
                      rounded
                      solo
                      hide-details
                      flat
                      height="50px"
                      v-model="credentials.username"
                      :error="errors && !$v.credentials.username.required || !$v.credentials.username.email"
                    ></v-text-field>
                    <v-text-field 
                      class="password"
                      :class="{'password': !errors && $v.credentials.password.required,
                      'password-error': errors && !$v.credentials.password.required }"
                      name="password"
                      type="password"
                      placeholder="Password"
                      rounded
                      solo
                      flat
                      hide-details
                      height="50px"
                      v-model="credentials.password"
                      :error="errors && !$v.credentials.password.required"
                    ></v-text-field>
                    <v-card-text class="text-right pt-0 mb-3">
                      <a class="forgot-psw-link" @click="forgotPasswordRedirect()">Forgot password?</a>
                    </v-card-text>
                </v-card-text>
                <v-card-actions class="justify-center mt-0 pt-0">
                  <v-btn 
                    class="text-none mb-0 pb-0"
                    id='signin'
                    type="submit"
                    rounded
                    min-height="50px"
                    height="50px"
                    max-height="50px"
                    :disabled="errors || !$v.credentials.password.required || !$v.credentials.username.required || !$v.credentials.username.email"
                  >
                  <v-icon id="spinner" medium center v-if="loading">fas fa-spinner fa-spin</v-icon>
                  <span v-else>Log In</span>
                  </v-btn>
                </v-card-actions>
                <v-card-text class="text-center">
                  <p class="create-account-text">Don't have an account? </p>
                  <a class="create-account-link" @click="signupRedirect()">Sign Up</a>
                </v-card-text>
              </v-card>
            </v-form>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import ErrorSnackbar from "./ErrorSnackbar";

import { required, email } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      credentials: {
        username: "",
        password: ""
      },
      errors: false,
      errorSnackbar: false,
      loading: false
    };
  },
  mixins: [validationMixin],
  computed: mapGetters(["cognitoInfo", "loggedIn", "verified", "authErrors"]),
  validations: {
    credentials: {
      username: { required, email },
      password: { required }
    }
  },
  methods: {
    ...mapActions(["signin"]),
    async onSignin() {
      if (this.$v.$invalid) {
        this.errors = true;
      } else {
        this.loading = true;

        const credentials = {
          username: this.credentials.username.toLowerCase(),
          password: this.credentials.password
        };
        
        await this.signin(credentials);

        if (this.authErrors.isError) this.errorSnackbar = true;

        if (!this.verified) {
          this.$router.push("/signup/verify");
        }

        if (this.loggedIn) {
          return this.$router.push("/environments");
        }
        this.loading = false;
      }
    },
    signupRedirect() {
      this.$router.push("/signup");
    },
    forgotPasswordRedirect() {
      this.$router.push("/password/reset");
    }
  },
  components: {
    ErrorSnackbar
  }
};
</script>

<style scoped>
.content {
  background-image: url("../../assets/casestudies-banner.png");
  background-size: cover;
}

.login .v-input__slot {
  background-color: #ffffff;
  font: 1.2rem "Montserrat" !important;
}

#signin {
  background-color: #6db42c;
  color: #ffffff !important;
  width: 100%;
  height: 5vh !important;
  font: 1.2rem "Montserrat";
  border-radius: 12vw;
}

#signin:focus::before {
  opacity: 0 !important;
}

.password .v-input__slot {
  background-color: #ffffff;
  font: 1.2rem "Montserrat";
}

.title-container {
  text-align: center;
  margin-bottom: 10vh !important;
  margin-top: 2vh !important;
}

#icon-style {
  color: #ffffff !important;
  margin-top: 0.3vh !important;
}

.icon-subtitle {
  color: #ffffff !important;
  margin-bottom: 8vh !important;
  font: bold 1rem "Montserrat";
}

.login-title {
  color: #ffffff !important;
  font: Bold 2.3rem "Montserrat";
}

.login-subtitle {
  color: #ffffff !important;
  font: 1rem "Montserrat";
}

.underscore {
  background-color: #6db42c;
  border: 0.2vh solid #6db42c;
  border-radius: 0.2vh;
  width: 3vw;
  margin: auto;
  margin-top: 1.6vh !important;
  margin-bottom: 3vh !important;
}

.create-account-text {
  color: #ffffff;
  display: inline;
  font: 1rem "Montserrat";
  letter-spacing: 0.1vw;
}

a.create-account-link {
  color: #6db42c;
  font: bold 1rem "Montserrat";
  letter-spacing: 0.1vw;
  text-decoration: none;
}

a.create-account-link:hover {
  text-decoration: underline;
}

#spinner {
  color: white !important;
}

.login >>> .v-input__control {
  min-height: auto !important;
  border-radius: 12vw !important;
  margin-bottom: 4%;
  font: 1rem "Montserrat";
}

.password >>> .v-input__control {
  min-height: auto !important;
  border-radius: 12vw !important;
  margin-bottom: 1%;
  font: 1rem "Montserrat";
}

.forgot-psw-link {
  color: #6db42c;
  font: bold 0.75rem "Montserrat";
  letter-spacing: 0.1vw;
  text-decoration: none;
}
</style>


